module.exports = __webpack_public_path__ + "img/slaapkamerschuur3.88142488.jpg";